// LCTO-1614: teto de espera pela classificação automática do documento.
//
// Enquanto o arquivo está em `classifying`, a pergunta fica bloqueada e o front
// aguarda o push do notifier. Se o n8n nunca responder, o arquivo nunca
// destravaria — o texto já foi extraído, então depois do teto tratamos como
// processado e a substituição volta a ser escolha manual.
//
// Usado nos dois lados: no card do arquivo (rótulo e pendência) e no destrave
// da entrevista. Manter em um lugar só evita que um destrave e o outro
// continue preso.
export const CLASSIFICATION_TIMEOUT_MS = 2 * 60 * 1000

// Quanto falta do teto (0 = sem classificação pendente ou já vencida; Infinity =
// timestamp ilegível, que nunca vence). O front agenda o destrave neste prazo, já
// que nenhum push chega quando o n8n silencia.
export const classificationRemainingMs = (
    classificationRequestedAt?: string | null
): number => {
    if (!classificationRequestedAt) {
        return 0
    }

    // Mongo/Motor devolve UTC sem offset nesta aplicacao. JavaScript trataria
    // esse ISO como horario local; acrescentar Z evita um timeout adiantado ou
    // atrasado conforme o fuso do navegador.
    const hasTimezone = /(Z|[+-]\d{2}:?\d{2})$/i.test(classificationRequestedAt)
    const utcTimestamp = hasTimezone
        ? classificationRequestedAt
        : `${classificationRequestedAt}Z`
    const elapsed = Date.now() - new Date(utcTimestamp).getTime()

    if (!Number.isFinite(elapsed)) {
        return Number.POSITIVE_INFINITY
    }

    return Math.max(0, CLASSIFICATION_TIMEOUT_MS - elapsed)
}

export const classificationExpired = (
    classificationRequestedAt?: string | null
): boolean =>
    Boolean(classificationRequestedAt) &&
    classificationRemainingMs(classificationRequestedAt) === 0
